/* Components */
import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Link } from 'react-router';
import { forgotPasswordUpdateUserPassword, userLogin } from '../actions';
import { checkPassStrength } from 'utils/password';
import get from 'lodash.get';
import isBlank from 'utils/isBlank';
import { Header } from 'modules/new-applications/components/NewLogin/index.js';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import {
  USER_PASSWORD_RESET_ERROR,
  USER_PASSWORD_RESET_TOKEN_NOT_FOUND_ERROR,
} from '../constants';
import isPresent from 'utils/isPresent';

function validatePasswordMatch(value) {
  const { password } = this.parent;

  return value === password;
}

const SCHEMA = yup.object().shape({
  password: yup.string().min(8, 'Password must be at least 8 characters long'),
  confirmPassword: yup
    .string()
    .test('confirm-password', 'Passwords must match', validatePasswordMatch),
});

const getRedirectPath = (referrer, defaultPath) => {
  if (isPresent(referrer)) {
    return referrer;
  }

  return defaultPath;
};

function PasswordForm(props) {
  const { dispatch, location } = props;
  const { errors, handleSubmit, register } = useForm({
    mode: 'onBlur',
    validationSchema: SCHEMA,
  });

  const {
    query: { t, e, referrer },
  } = location;

  const email = e.replace(' ', '+');

  const onSubmit = (data) => {
    const { password } = data;

    const redirectPath = getRedirectPath(referrer, '/dashboard');

    dispatch(
      forgotPasswordUpdateUserPassword(
        t,
        email,
        password,
        () => {
          dispatch(
            userLogin(email, password, redirectPath, () => null, null, null)
          );
        },
        (error) => {
          switch (error.response.data.error) {
            case 'token_not_found':
              dispatch({
                payload: error,
                type: USER_PASSWORD_RESET_TOKEN_NOT_FOUND_ERROR,
              });
              break;
            default:
              dispatch({
                payload: error,
                type: USER_PASSWORD_RESET_ERROR,
              });
              break;
          }
        }
      )
    );
  };

  return (
    <div className="container has-text-centered mt-100">
      <div className="has-text-centered columns pt-1">
        <div className="column container has-text-centered box mb-5 is-two-thirds-tablet is-one-quarter-desktop">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="field px-4">
              <div className="has-text-grey-darker mt-4 is-size-large has-text-weight-normal m5-4">
                Pick a password
              </div>

              <div className="control mt-6 has-icons-left has-icons-right">
                <span className="icon is-small is-left ">
                  <i className="fa fa-lock"></i>
                </span>
                <input
                  className="input is-primary is-focused has-text-weight-normal"
                  name="password"
                  type="password"
                  placeholder="password"
                  required
                  ref={register}
                />
                <p className="has-text-left mt-4 has-text-weight-normal has-text-danger is-size-small">
                  {get(errors, 'password.message', <span>&nbsp;</span>)}
                </p>
              </div>

              <div className="control mt-3 has-icons-left has-icons-right">
                <span className="icon is-small is-left ">
                  <i className="fa fa-lock"></i>
                </span>
                <input
                  className="input is-primary is-focused has-text-weight-normal"
                  name="confirmPassword"
                  type="password"
                  placeholder="confirm password"
                  required
                  ref={register}
                />
                <p className="has-text-left mt-4 has-text-weight-normal has-text-danger is-size-small">
                  {get(errors, 'confirmPassword.message', <span>&nbsp;</span>)}
                </p>
              </div>
            </div>
            <div className="field mt-4">
              <div className="control">
                <button className="button is-primary is-rounded" type="submit">
                  Set password
                </button>
              </div>
            </div>
          </form>
          <div className="field is-vcentered">
            <div className="column">
              <Link
                to={getRedirectPath(referrer, '/')}
                className="is-primary has-text-centered has-text-weight-normal"
              >
                Go Back
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SetPassword(props) {
  return (
    <div className="hero">
      <div className="hero-body">
        <div className="container is-widescreen">
          <Header />
          <PasswordForm {...props} />
        </div>
      </div>
    </div>
  );
}

export default connect((state, ownProps) => {
  var strength = 0;
  if (state.register.password.length > 0) {
    strength = checkPassStrength(state.register.password);
  }
  let email;
  if (state.current_user.data.data) {
    email = state.current_user.data.data.attributes.email;
  }

  return {
    password: state.register.password,
    confirm_password: state.register.confirm_password,
    strength: strength,
    email: email,
    missing_user: !(
      state.current_user.data.data && state.current_user.data.data.id
    ),
  };
})(SetPassword);
